/**
 * @description: 表格配置
 */
export const tableColumns = [
    { prop: 'noticeName', label: '公告名称'},
    // { prop: 'noticeContent', label: '公告内容'},
    { prop: 'publishTime', label: '发布时间'},
    { slotName: 'status', label: '状态'},
    { slotName: 'action', label: '操作'},
]
